import { useTranslations } from 'next-intl';
import TimeSlot from '@atoms/TimeSlot/TimeSlot';
import type { AxfoodTimeSlotViewModel } from '@occ/api-client';
import { StyledContainer, StyledEmptyContainer } from './TimeSlots.styles';
import Text from '@atoms/Text/Text';
import { RefObject } from 'react';

interface Props {
  slots: Array<AxfoodTimeSlotViewModel>;
  selectedSlot: AxfoodTimeSlotViewModel | null;
  onSlotClick: (slot: AxfoodTimeSlotViewModel | null) => void;
  deliveryMode?: 'homeDelivery' | 'pickUpInStore';
  ref?: RefObject<HTMLDivElement | null>;
}

const TimeSlots = ({ slots, selectedSlot, onSlotClick, deliveryMode, ref }: Props) => {
  const t = useTranslations('timeSlots');

  return (
    <StyledContainer
      data-testid="slot-time-picker"
      $deliveryMode={deliveryMode}
      $selectedSlot={!!selectedSlot}
      ref={ref}
    >
      {slots?.length ? (
        slots.map((slot) => {
          const selected = selectedSlot?.code === slot.code;
          return <TimeSlot slot={slot} key={slot.code} selected={selected} onClick={onSlotClick} />;
        })
      ) : (
        <StyledEmptyContainer>
          <Text type="subhead" size="medium" color="darkGray">
            {t('noAvailableTimes')}
          </Text>
        </StyledEmptyContainer>
      )}
    </StyledContainer>
  );
};

export default TimeSlots;
